/* eslint-disable */
import React, { useState, useEffect }  from 'react'
import { DatePicker, Tooltip } from 'antd'
import dayjs from 'dayjs'
import { handleControl } from './control'
import { renderLabelString } from '@/utils/renderUtils'
import { title } from 'process'

const baseDay = 86499999
const DateRangePickerC = (props) => {
  const {
    propsClassName, propsClassSpan, propsStyle, disableds, allowClears,// 样式 className
    modalProps, mode, label, formatType, picker, gap, allowCrossYear,// 组件 功能参数
    query, value, searchKey, dateStrValue, dateOfType,// 组件 数据源
    path, clearKey, requestType, killPending, // 请求相关控制数据
    action, actionChange, resAction, headerchange // 请求方法
  } = props

  const handleValue = {
    [searchKey[0]]: query[searchKey[0]] ? dayjs(query[searchKey[0]]): undefined,
    [searchKey[1]]: query[searchKey[1]] ? dayjs(query[searchKey[1]]): undefined,
  }
  const handleErr = {
    open: false,
    title: ''
  }
  const [ useValue, setUseValue ] = useState(handleValue)
  const [ useError, setUseError] = useState(handleErr)

  useEffect(() => {
    setUseValue(handleValue)
  }, [query.refQ, query[searchKey[0]], query[searchKey[1]]])
  const handleChange = ({e, eStr, dateArrIndex}) => {
    const formatDate = {
      ...useValue,
      [searchKey[dateArrIndex]]: e ? e : undefined
    }
    setUseValue(formatDate)
    if ((!formatDate[searchKey[0]] && formatDate[searchKey[1]]) || (formatDate[searchKey[0]] && !formatDate[searchKey[1]])) { return }

    let formatValue = {}
    switch (true) {
      case (!e): {
        formatValue = formatDate
        break
      }
      // dateStrValue === true, 提交参数 为 字符串 根据 picker 类型
      case (dateStrValue): {
        formatValue = {
          [searchKey[0]]: dayjs(formatDate[searchKey[0]]).format(formatType),
          [searchKey[1]]: dayjs(formatDate[searchKey[1]]).format(formatType)
        }
        break
      }
      // dateOfType === true, 提交参数为，去除时分秒，根据picker参数
      case (dateOfType): {
        // console.log('dateOfType')
        formatValue = {
          [searchKey[0]]: +dayjs(formatDate[searchKey[0]]).startOf(picker || 'day'),
          [searchKey[1]]: +dayjs(formatDate[searchKey[1]]).endOf(picker || 'day')
        }
        break
      }
      // 默认 转换 时间戳
      default: {
        formatValue = {
          [searchKey[0]]: +dayjs(formatDate[searchKey[0]]),
          [searchKey[1]]: +dayjs(formatDate[searchKey[1]])
        }
        break
      }
    }

    // 日期范围 限制
    if (allowCrossYear) {
      const checkCrossYear = formatDate[searchKey[0]].year() !== formatDate[searchKey[1]].year()
      setUseError({
        open: checkCrossYear,
        title: '不允许跨年'
      })
      if (checkCrossYear) {
        return
      }
    }
    if (gap > 0) {
      const checkGap = (formatDate[searchKey[1]] - formatDate[searchKey[0]]) / baseDay + 1 > gap
      setUseError({
        open: checkGap,
        title: `日期范围超过${gap}天`
      })
      if (checkGap) {
        return
      }
    }

    // ----- 提交组件 -----------
    // console.log('formatValue', formatValue)
    handleControl(
      props,
      formatValue
    )
  }

  const disabledStartDate = (current) => {
    if (useValue[searchKey[1]]) {
      const endDate = dayjs(useValue[searchKey[1]])
      return current > endDate
    }
    return false
  }
  const disabledEndDate = (current) => {
    if (useValue[searchKey[0]]) {
      const startDate = dayjs(useValue[searchKey[0]])
      return current < startDate
    }
    return false
  }
  return (
    <div className={propsClassName} style={propsStyle}>
      <span className={propsClassSpan} style={{ marginRight: '-2px' }}>{renderLabelString(label)}</span>
      <Tooltip open={useError.open} title={useError.title}>
        <DatePicker
          disabledDate={(current) => disabledStartDate(current)}
          disabled={disableds[0]}
          placeholder='开始日期'
          allowClear={allowClears[0]}
          {...modalProps}
          status={useError.open ? 'error': null}
          value={useValue[searchKey[0]]}
          onChange={(e, eStr) => handleChange({e, eStr, dateArrIndex: 0})}
        />
        {` ~ `}
        <DatePicker
          disabledDate={(current) => disabledEndDate(current)}
          disabled={disableds[1]}
          placeholder='结束日期'
          allowClear={allowClears[1]}
          {...modalProps}
          status={useError.open ? 'error': null}
          value={useValue[searchKey[1]]}
          onChange={(e, eStr) => handleChange({e, eStr, dateArrIndex: 1})}
        />
      </Tooltip>
    </div>
  )
}
export default DateRangePickerC

DateRangePickerC.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  modalProps: {},
  picker: undefined,
  query: {},
  disableds: [false, false],
  allowClears: [true, true],
  allowCrossYear: false, // 是否允许跨年
  dateStrValue: false,
  dateOfType: true,
  formatType: 'YYYY-MM-DD',
  searchKey: ['start_date', 'end_date'],
  ending: false,
  killPending: false,
  gap: 0
}